import { c as _c } from "react/compiler-runtime";
import type { NormalChatMessage } from '@module/types/centrifuge/public-message';
import { useState } from 'react';
interface Params {
  chatData: NormalChatMessage;
  // 해당 방송의 bj(시청자 본인 == BJ)인지 여부
  isRoomMaster?: boolean;
  // 브랜드가 자동 번역을 지원하는지 (pandatv: true, fanza: false)
  autoEnabled?: boolean;
}

/**
 * 채팅 번역의 헤드리스 로직 코어: 번역 결과 state + 자동/수동(isAuto) 판정을 소유한다.
 * 트리거/결과의 배치(인라인·블록)는 소비처가 결정하고, 이 훅은 "무엇을 보여줄지"만 정한다.
 * pandatv(ChatTranslatePanel 경유) · fanza pc/mobile 네 앱이 공유한다.
 */
const useChatTranslateController = t0 => {
  const $ = _c(5);
  const {
    chatData,
    isRoomMaster,
    autoEnabled
  } = t0;
  const [translatedMessage, setTranslatedMessageState] = useState(null);
  const [hasError, setHasError] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = message => {
      setHasError(false);
      setTranslatedMessageState(message);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setTranslatedMessage = t1;
  const isAuto = !!autoEnabled && !!isRoomMaster && chatData.receivedInBatchMode === false;
  let t2;
  if ($[1] !== hasError || $[2] !== isAuto || $[3] !== translatedMessage) {
    t2 = {
      translatedMessage,
      setTranslatedMessage,
      isAuto,
      hasError,
      setHasError
    };
    $[1] = hasError;
    $[2] = isAuto;
    $[3] = translatedMessage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default useChatTranslateController;